import React, {useEffect, useState} from 'react';
import {parseJSON}                  from '../_helpers/fetch';

interface ColorClasses {
    [key: string]: string
}

interface StatusApiOutput {
    page: object,
    status: {
        indicator: 'none' | 'minor' | 'major' | 'critical' | 'maintenance'
        description: string
    }
}

const PageStatus = () => {

    const defaultColorClass: string = 'text-dark';
    const defaultStatusText = 'Unknown Status';
    const intervalTimeout: number = 60000; // 1 minute
    const colorClasses: ColorClasses = {
        none: 'text-success',
        minor: 'text-warning',
        major: 'text-danger',
        critical: 'text-danger',
        maintenance: 'text-info'
    };

    const [statusMessage, setStatusMessage] = useState<string>(defaultStatusText);
    const [colorClass, setColorClass] = useState<string>();

    useEffect(() => {
        runStatusCheck();
        const intervalId = setInterval(() => runStatusCheck(), intervalTimeout);

        // Cleanup when the component is unloaded
        return () => {
            clearInterval(intervalId)
        }
    }, [])

    const runStatusCheck = () => {
        fetch('https://fletch.statuspage.io/api/v2/status.json')
            .then(parseJSON)
            .then(({status, ok, json}: { status: number, ok: boolean, json: any }) => {
                if (ok || status === 200) {
                    if (json.hasOwnProperty('status')) {
                        const {indicator, description}: StatusApiOutput['status'] = json.status;
                        setStatusMessage(description);
                        setColorClass(() => colorClasses.hasOwnProperty(indicator) ? colorClasses[indicator] : defaultColorClass);
                    }
                } else {
                    throw new Error('Status Unavailable')
                }
            })
            .catch(error => {
                console.log(error);
                setStatusMessage(defaultStatusText);
                setColorClass(defaultColorClass);
            });
    }

    return (
        <div className="d-flex">
            <div>
                <i className={`fas fa-fw fa-circle ${colorClass || defaultColorClass}`} />
            </div>
            <div className="mx-3 text-muted">
                <a href="https://fletch.statuspage.io/" target="_blank">{statusMessage}</a>
            </div>
        </div>
    );
};

export default PageStatus;
